export type MonitoringTask = {
  id: string
  data?: Record<string, any>
  permissions?: Record<string, any>
}

export const monitoringTemplate = {
  fields: [{ name: 'inn', type: 'text', title: 'ИНН', example: 'Введите ИНН' }],
}
